import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { buildUnsubscribeApiUrl } from '../utils/unsubscribeUrl';

/**
 * Legacy /unsubscribe?email=... links redirect to the one-click API handler.
 * New emails use the API URL directly in the footer.
 */
const PublicUnsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const email = searchParams.get('email')?.trim();
    if (!email) {
      setError('Missing email address. Use the unsubscribe link from your email.');
      return;
    }

    const apiUrl = buildUnsubscribeApiUrl({
      email,
      userId: searchParams.get('userId') || undefined,
      workspaceId: searchParams.get('workspaceId') || undefined,
      campaignId:
        searchParams.get('campaignId') ||
        searchParams.get('campaign') ||
        undefined,
    });

    window.location.replace(apiUrl);
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {!error && (
          <>
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto mb-4" />
            <p className="text-gray-700">Processing your unsubscribe request…</p>
          </>
        )}
        {error && (
          <>
            <div className="text-amber-500 text-5xl mb-4">!</div>
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to unsubscribe</h1>
            <p className="text-gray-600">{error}</p>
            <Link to="/" className="inline-block mt-6 text-blue-600 hover:underline">
              Back to home
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PublicUnsubscribe;
